<h2 mat-dialog-title >Download multiple GeoTIFFs</h2>

<mat-dialog-content >
  <div>The selected area exceeds the maximum download size. Export the area as multiple GeoTIFFs.</div>
  <div class="export-options">
    <div class="font-weight-bolder">Export by:</div>
    <mat-radio-group [(ngModel)]="this.zipExport" class="radio-group">
      <mat-radio-button [value]="true" class="radio-button">Zip file</mat-radio-button>
      <mat-radio-button [value]="false" class="radio-button">Individual files</mat-radio-button>
    </mat-radio-group>
  </div>
</mat-dialog-content>
<mat-dialog-actions >
  <button matButton="elevated" mat-dialog-close >Cancel</button>
  <button matButton="elevated"  (click)="multiExportGeoTIFF()" [mat-dialog-close]="true">Export Multiple</button>
</mat-dialog-actions>
